import { COLOR_BRAND_EMERALD_50, IconCalendar, IconFileText, Text } from '@consumidor-positivo/aurora';
import './styles.scss'

type InfoBoxProps = {
  stepSlug: 'monthlyExpense' | 'annuity';
};

export const InfoBox = ({ stepSlug }: InfoBoxProps) => {
  const content = {
    monthlyExpense: {
      icon: <IconFileText rawColor={COLOR_BRAND_EMERALD_50} />,
      title: 'De onde vem essa informação?',
      description: (
        <span>
          Nós analisamos seu Cadastro Positivo <strong>para entregar uma experiência personalizada.</strong>
        </span>
      ),
    },
    annuity: {
      icon: <IconCalendar rawColor={COLOR_BRAND_EMERALD_50} />,
      title: 'O que é anuidade?',
      description: 'É uma tarifa paga para contratar um cartão de crédito, cobrada diretamente na fatura.',
    },
  };

  return (
    <div className='mm-info-box'>
      {content[stepSlug].icon}
      <Text as="h3" variant="body-medium" weight="semibold">
        {content[stepSlug].title}
      </Text>
      <Text as="p" variant="body-small" color="secondary">
        {content[stepSlug].description}
      </Text>
    </div>
  );
};
